import { render, staticRenderFns } from "./version-announcement-template.vue?vue&type=template&id=13be4807&scoped=true&"
import script from "./version-announcement-template.vue?vue&type=script&lang=js&"
export * from "./version-announcement-template.vue?vue&type=script&lang=js&"
import style0 from "./version-announcement-template.vue?vue&type=style&index=0&id=13be4807&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be4807",
  null
  
)

export default component.exports